<template>
  <div ref="wrapper" class="flex h-0 select-none flex-nowrap">
    <div
      v-for="(entry, i) in entries"
      :key="`${entry.id}_${entry.type}`"
      class="z-10 mr-1 inline-block h-full"
    >
      <IconContainer
        aria-haspopup="menu"
        aria-controls="paragraph-context-menu"
        :data-pw="`icon-container-${entry.id}`"
        :entry="entry"
        @contextmenu="handleContextMenu(entry, i, $event)"
      />
      <span
        v-if="menuOpen === i"
        class="absolute top-3.5 font-black text-lexmea-blue-200"
        >|</span
      >
      <ContextMenu
        v-if="entry.editable"
        :items="[entry]"
        :movable="true"
        :open="menuOpen === i"
        :legalText="legalText"
        :legalTextParagraph="legalTextParagraph"
        @close="updateMenuOpen(-1)"
        @delete="$emit('delete', $event)"
        @move="$emit('move', $event)"
        @editLink="$emit('editLink', $event)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ILegalText } from "~/models/ILegalText";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";
import type {
  ILinkChain,
  INote,
  IParagraphEntry,
  ISchema,
  IUserEntry,
} from "~/models/IUserEntry";

defineProps<{
  entries: Array<ISchema | INote | ILinkChain>;
  legalText: ILegalText;
  legalTextParagraph: ILegalTextParagraph;
}>();

defineEmits<{
  delete: [entry: IParagraphEntry];
  move: [entry: ILinkChain | INote | ISchema];
  editLink: [entry: ILinkChain];
}>();

const menuOpen = ref(-1);

const { setActive } = useSetActiveEntry();

const { updateShowPreview } = useProvideParagraphPreview(true);

const { isSmallerThanSm } = useLexMeaTailwindBreakpoints();

const updateMenuOpen = (i: number) => {
  menuOpen.value = i;
  updateShowPreview(menuOpen.value === -1);
};

const wrapper = ref<HTMLElement>();
const { withinTeleport } = useWithinTeleport(wrapper);

const handleContextMenu = async (
  entry: IUserEntry,
  i: number,
  event: MouseEvent
) => {
  if (withinTeleport.value) {
    return;
  }

  updateMenuOpen(i);
  if (
    !isSmallerThanSm.value &&
    (entry.type === "schema" || entry.type === "note")
  ) {
    // set active if clicked primary mouse button and not secondary mouse button
    if (event.button === 1) {
      await setActive(entry);
    }
  }
};
</script>
